import { Box, Drawer } from '@mui/material';
import useMobileMenu from 'hooks/useMobileMenu';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import filterSlice, { filterActions } from 'redux/slices/filterSlice';
import { CollectionFilter } from './CollectionFilter';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CloseIcon from '@mui/icons-material/Close';
import FlexBox from 'components/shared/FlexBox';

const CollectionFilterDrawer: React.FC<CollectionFilterDrawerProps> = ({
    collectionId,
    search,
}) => {
    const dispatch = useAppDispatch();

    const mobileMenu = useMobileMenu();

    const { filter } = useAppSelector((state) => state.filter);

    const handleFilter = (items) => {
        dispatch(filterActions.setCollectionFilter(items));
    };

    const closeHandler =
        (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
            if (
                event.type === 'keydown' &&
                ((event as React.KeyboardEvent).key === 'Tab' ||
                    (event as React.KeyboardEvent).key === 'Shift')
            ) {
                return;
            }

            mobileMenu.showCollectionFilter(open);
        };
    return (
        <>
            <Drawer
                anchor={'left'}
                open={mobileMenu.mobileMenuStates.filter.open}
                onClose={closeHandler(false)}
            >
                <FlexBox flexDirection="column" padding={'15px'}>
                    <Box sx={{ paddingBlock: '5px', alignSelf: 'end' }}>
                        <CloseIcon
                            sx={{ cursor: 'pointer' }}
                            onClick={closeHandler(false)}
                        />
                    </Box>

                    <CollectionFilter
                        handleFilter={handleFilter}
                        collectionId={collectionId}
                        search={search}
                        preSetItems={filter.filteredItems}
                        priceRange={filter.priceRange}
                    />
                </FlexBox>
            </Drawer>
        </>
    );
};

export default CollectionFilterDrawer;

type CollectionFilterDrawerProps = {
    collectionId: number;
    search: string;
};
